import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from '../shared/services/ecommerce/localstorage.service';

@Injectable({
	providedIn: 'root'
})
export class Paso1Guard implements CanActivate {
	private localStorageService = inject(LocalStorageService);
	private datosBusqueda = this.localStorageService.getItemByIndex('busqueda', 0);
	private itinerarioIda = this.localStorageService.getItemByIndex('itinerarioIda', 0);

	constructor(private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const { url_amigable, fecha_ida } = this.datosBusqueda;
		const paramIda = route.paramMap.get('tramo');

		if (!this.datosBusqueda) {
			this.router.navigate(['/']);
			return false;
		}

		if (paramIda !== 'ida' && paramIda !== 'vuelta') {
			this.router.navigate([`/pasajes-en-bus/paso1/${url_amigable}/${fecha_ida}/ida`]);
			return false;
		}
		return true;
	}
}
